import http from "@/utils/http";
import { getCurrentLocale } from "@/utils/common";

const base = (token: string) => {
  const currentLocale = getCurrentLocale();
  return `${process.env.REACT_APP_SOPHYAPP_API_URL}/${currentLocale}/react/${token}`;
};

export const getNotifications = async (token: string, filters = {}) => {
  const response = await http.get(`${base(token)}/notifications`, {
    params: filters,
  });
  return response.data;
};

export const getNotification = async (notificationId: string, token: string) => {
  const response = await http.get(`${base(token)}/notifications/${notificationId}`);
  return response.data;
};

export const markNotificationAsRead = async (notificationId: string, token: string) => {
  const response = await http.post(`${base(token)}/notifications/${notificationId}/mark_as_read`);
  return response.data;
};

export const markAllNotificationsAsRead = async (token: string) => {
  const response = await http.post(`${base(token)}/notifications/mark_all_as_read`);
  return response.data;
};

export const getUnreadNotificationCount = async (token: string) => {
  const response = await http.get(`${base(token)}/notifications/unread_count`);
  return response.data;
};

export const createNotification = async (notificationData: any, token: string) => {
  const response = await http.post(`${base(token)}/notifications`, notificationData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};


